const buttons = document.querySelectorAll("[data-js-close-button]")

const closeButtons = {
	bindEvents: () => {
		if (!buttons.length) return
		document.addEventListener("click", function (e) {

			for (var i = 0; i < buttons.length; i++) {
				if (buttons[i].contains(e.target)) {
					closeButtons.closeElement(buttons[i].dataset.jsCloseButton)
				}
			}
		})
	},

	closeElement: (cssSelector) => {
		let element = document.querySelector(cssSelector)
		if (element) {
			element.classList.add("is-hidden")
		}
	},
}

export default closeButtons
